import { useState, useEffect } from "react";
import Style from "./ApartmentsDetailStyle";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";
import Spinner from "../../shared/Spinner/Spinner";
import ListUserApartment from "./ListUserApartment";
import { CentsToHuman, CurrencyToCents, MaskPrice } from "../../utils";

export default function ApartmentsDetail(props) {


  const [apartmentNumber, setApartmentNumber] = useState("");
  const [floor, setFloor] = useState("");
  const [planId, setPlanId] = useState("");
  const [blockName, setBlockName] = useState("");
  const [entryPayed, setEntryPayed] = useState("R$ 0,00");

  const [plans, setPlans] = useState([] as any);
  const [users, setUsers] = useState([] as any);
  const [userApartments, setUserApartments] = useState([] as any);
  const [contract, setContract] = useState([] as any);
  const [loading, setLoading] = useState(true);
  const [showPopUp, setShowPopUp] = useState(false);
  const [message, setMessage] = useState({ success: "", error: "" });
  const [bodyPopUp, setBodyPopUp] = useState({ title: "", body: "", primaryText: "", secondaryText: "", primaryOnClick: {} as any })
  const apartmentId = parseInt(props.match.params.apartmentId) || 0;
  const creatingNew = apartmentId <= 0;

  useEffect(() => {
    LoadApartment();
    LoadUserApartments();
    LoadPlans();
    LoadUsers();
    LoadContract();
  }, []);

  async function LoadApartment() {
    try {
      setLoading(true);
      const result = await api.get(`/enterprises/blocks/apartments/${apartmentId}`);
      if (result.data.success) {
        const apartmentData = result.data.apartmentData;
        setApartmentNumber(apartmentData.apartmentNumber);
        setFloor(apartmentData.floor);
        setPlanId(apartmentData.planId);
        setEntryPayed(CentsToHuman(apartmentData.entryPayed));
        LoadBlock(apartmentData.enterpriseId, apartmentData.blockId);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

  }

  async function LoadBlock(enterpriseId, blockId) {
    try {
      setLoading(true);
      const result = await api.get(`/enterprises/${enterpriseId}/blocks`);
      if (result.data.success) {
        const thisBlock = result.data.blocks.find(block => block.id === blockId);
        setBlockName(thisBlock.name);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function LoadUserApartments() {
    try {
      setLoading(true);
      const result = await api.get(`/enterprises/usersApartments/${apartmentId}`);
      if (result.data)
        setUserApartments(result.data.userApartment);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function LoadContract() {
    try {
      setLoading(true);
      const result = await api.get(`/contracts/apartment/${apartmentId}`);
      if (result.data)
        setContract(result.data.apartmentContracts);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function LoadPlans() {
    try {
      setLoading(true);
      const result = await api.get(`/plans`);
      if (result.data.success)
        setPlans(result.data.plans);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function LoadUsers() {
    try {
      setLoading(true);
      const result = await api.get(`/users`);
      if (result.data)
        setUsers(result.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function onEdit() {
    try {
      const data = {
        planId: planId, apartmentNumber: apartmentNumber, floor: floor,
        entryPayed: CurrencyToCents(entryPayed).toString()
      }
      await api.put(`/enterprises/blocks/apartments/${apartmentId}`, data);

      onClosePopup();
      setMessage({ success: `Apartamento editado com sucesso!`, error: "" })
      setLoading(false);
      props.history.goBack()
    }
    catch (error: any) {
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
      onClosePopup();
    }
  }

  async function onDelete() {
    try {
      await api.delete(`/enterprises/blocks/apartments/${apartmentId}`);
      onClosePopup();
      setMessage({ success: `Apartamento deletado com sucesso!`, error: "" })
      setLoading(false);
      props.history.goBack()
    }
    catch (error: any) {
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
      onClosePopup();
    }
  }
  async function onAddUserApartment(userId) {
    try {
      const data = { userId: userId }
      await api.post(`/enterprises/usersApartments/${apartmentId}`, data);
      onClosePopup();
      setMessage({ success: `Usuário adicionado ao apartamento com sucesso!`, error: "" })
      LoadUserApartments();
      LoadApartment();
    }
    catch (error: any) {
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
      onClosePopup();
    }
  }
  async function onDeleteUserApartment(userApId) {
    try {
      await api.delete(`/enterprises/usersApartments/${userApId}`);
      onClosePopup();
      setMessage({ success: `Usuário removido do apartamento com sucesso!`, error: "" })
      LoadUserApartments();
      LoadApartment();
    }
    catch (error: any) {
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
      onClosePopup();
    }
  }

  function onShowPopUpEdit() {
    setBodyPopUp({
      title: creatingNew ? "Cadastro de apartamentos" : "Edição de apartamentos",
      body: "Você tem certeza que deseja " + (creatingNew ? "cadastrar" : "editar") + " este apartamento?",
      primaryText: "Confirmar",
      secondaryText: "Fechar",
      primaryOnClick: () => onEdit()
    })
    setShowPopUp(true);
  }

  function onShowPopUpAddUser(userId) {
    setBodyPopUp({
      title: "Adicionar usuário ao apartamento",
      body: `Você tem certeza que deseja adicionar este usuário ao apartamento?`,
      primaryText: "Confirmar",
      secondaryText: "Fechar",
      primaryOnClick: () => onAddUserApartment(userId)
    })
    setShowPopUp(true);
  }

  function onShowPopUpDelete() {
    setBodyPopUp({
      title: "Deleção de apartamentos",
      body: `Você tem certeza que deseja deletar este apartamento?`,
      primaryText: "Confirmar",
      secondaryText: "Fechar",
      primaryOnClick: () => onDelete()
    })
    setShowPopUp(true);
  }

  function onShowPopUpDeleteUser(userApId) {
    setBodyPopUp({
      title: "Deleção de usuário do apartamento",
      body: `Você tem certeza que deseja remover este usuário do apartamento?`,
      primaryText: "Confirmar",
      secondaryText: "Fechar",
      primaryOnClick: () => onDeleteUserApartment(userApId)
    })
    setShowPopUp(true);
  }

  function onClosePopup() {
    setShowPopUp(false);
  }

  return (
    <Style >
      <div className="apartmentDetail">
        <Spinner spinning={loading} />
        <TwoButtonsModal
          show={showPopUp}
          onHide={onClosePopup}
          loading={loading}
          title={bodyPopUp.title}
          body={bodyPopUp.body}
          secondaryText={bodyPopUp.secondaryText}
          secondaryOnClick={onClosePopup}
          secondaryDisabled={loading}
          primaryText={bodyPopUp.primaryText}
          primaryOnClick={bodyPopUp.primaryOnClick}
          primaryDisabled={loading}
        />
        <div>
          <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
          {!creatingNew && <button onClick={() => onShowPopUpDelete()} className=" btn-secondary delete">Deletar</button>}
        </div>
        {message.error && <p className="alert alert-error">Erro: {message.error}</p>}
        {message.success && <p className="alert alert-info">{message.success}</p>}
        <main>
          <form className="panel main-form" onSubmit={(e) => { e.preventDefault(); }}>
            <h2>{creatingNew ? "Criação do " : "Edição do "} apartamento</h2>
            <div>
              <label>Bloco:</label>
              <input type="text" defaultValue={blockName} disabled />
            </div>
            <div>
              <label>Andar:</label>
              <input type="text" defaultValue={floor} disabled />
            </div>
            <div>
              <label>Número do apartamento:</label>
              <input

                disabled={loading}
                value={apartmentNumber}
                onChange={e => setApartmentNumber(e.target.value)}
              />
            </div>
            <div>
              <label>Planta:</label>
              <select
                name="planId"
                value={planId}
                onChange={e => setPlanId(e.target.value)}>
                {plans.length > 0 && plans[0].id && plans.map(p =>
                  <option key={p.id} value={p.id}>{p.name}</option>
                )}
              </select>
            </div>
            <div>
              <label>Entrada Paga</label>
              <input
                autoComplete="off"
                disabled={loading}
                value={entryPayed}
                onChange={e => setEntryPayed(MaskPrice(e.target.value))} />

            </div>
            <button
              className=" btn btn-success btn-lg mt-4 "
              style={{ textAlign: "center" }}
              type="button"
              onClick={e => {
                e.preventDefault();
                onShowPopUpEdit();
              }}>{creatingNew ? "Cadastrar" : "Editar"}
            </button>
          </form>
          <div className="panel box">
            <div>
              <h2 className="centered">Contrato</h2>
              <div>Gerado: {contract.createdAt ? contract.createdAt.slice(0, 10) : "Não"}</div>
              <div>Assinado: {contract.signedContract ? "Sim" : "Não"}</div>
              <div className="centered">
                {contract.userId && <button
                  className="btn btn-success btn-lg mt-4"
                  type="button"
                  onClick={() => {
                    if (contract)
                      props.history.push("/contracts");
                  }}>Ver
                </button>}
              </div>

            </div>
            <div>
              <h2 className="centered">Pedido</h2>
              <div>Gerado: {contract.orders ? contract.orders.createdAt.slice(0, 10) : "Não"}</div>
              <br />
              <div className="centered">
                {contract.userId && <button
                  className="centered btn btn-success btn-lg mt-4 "
                  type="button"
                  onClick={() => {
                    props.history.push("/orders/" + contract.orderId);
                  }}>Ver
                </button>}
              </div>
            </div>
          </div>
        </main >
        {
          !creatingNew && (
            <ListUserApartment
              users={users}
              userApartments={userApartments}
              onAddUserApartment={userId => onShowPopUpAddUser(userId)}
              onDeleteUserApartment={userApId => onShowPopUpDeleteUser(userApId)} />
          )
        }
      </div >
    </Style >
  )
}
